(function () {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('BBPSSettingsViewController', BBPSSettingsViewController);

    BBPSSettingsViewController.$inject = ['$scope', '$state', '$rootScope', 'workflowSharedService', '$uibModalInstance', 'BBPSSettings', 'entity', 'Workflow', 'GlobalValues', 'ScreenLog', 'StaticLookUp', 'DateUtils'];

    function BBPSSettingsViewController($scope, $state, $rootScope, workflowSharedService, $uibModalInstance, BBPSSettings, entity, Workflow, GlobalValues, ScreenLog, StaticLookUp, DateUtils) {
        var vm = this;
        vm.clear = clear;
        vm.approveBBPSSetting = approveBBPSSetting;
        vm.rejectBBPSSetting = rejectBBPSSetting;
        vm.discardBBPSSetting = discardBBPSSetting;
        $scope.showButton = false;
        $scope.showDiscardButton = false;
        $scope.clicked = false;
        vm.globalValues = GlobalValues;
        vm.markupType = { value: 'Paise' };
        vm.entityOwnerType = vm.globalValues.getUser().entityOwnerType.shortName;
        vm.orgId = vm.globalValues.getOrgId();
        vm.noOfDecimals = vm.globalValues.getNumberOfDecimalsForRateInReports();

        //get RO/ED applicability method list lookup
        // StaticLookUp.getRoEdApplicabilityMethodList(function(result){
        //     vm.roEdApplicabilityMethodList = result;
        // });
        vm.hideRoEdApplicability = false;

        if(workflowSharedService.viewFrom == 'ManageBBPSSettings'){
        	vm.bbpsSetting = entity;    
        	vm.bank=vm.bbpsSetting.bank;
        	vm.branch=vm.bbpsSetting.branch;
       	 	$scope.showButton=false;
            vm.isModifyScreen = true;
        }
        else if(workflowSharedService.viewFrom == 'bbps_settingttodolist_checker') {
        	vm.bbpsSetting =  angular.fromJson($rootScope.payload); 
        	vm.bank=vm.bbpsSetting.bank;
        	vm.branch=vm.bbpsSetting.branch;
        	$scope.showButton=true;
        	$scope.showDiscardButton = false;
            vm.isModifyScreen = true;
        }
        else if(workflowSharedService.viewFrom == 'bbps_settingttodolist_maker') {
        	vm.bbpsSetting =  angular.fromJson($rootScope.payload); 
        	vm.bank=vm.bbpsSetting.bank;
        	vm.branch=vm.bbpsSetting.branch;
        	$scope.showButton=false;
        	$scope.showDiscardButton = true;
            vm.isModifyScreen = true;
        }
        else if(workflowSharedService.viewFrom=='bbps_settings_auditLog'){
        	vm.bbpsSetting =  angular.fromJson($rootScope.payload);   
        	vm.effectiveFromDateTime = DateUtils.convertDateTimeFromServer(vm.markup.effectiveFromDateTime);
            vm.bank=vm.bbpsSetting.bank;
            vm.branch=vm.bbpsSetting.branch;
        	$scope.showButton=false;
            vm.isModifyScreen = true;
        }

        function approveBBPSSetting() {
            BBPSSettings.approve({ "taskId": $rootScope.taskID }, onApproveSuccess, onApproveError);
            $uibModalInstance.dismiss('cancel');
        }

        function onApproveSuccess(result) {
            $rootScope.removeRow($rootScope.taskID);
        }
        function onApproveError(error) {

        }

        function rejectBBPSSetting() {
            Workflow.rejectTask($rootScope.taskID);
        }

        function discardBBPSSetting() {
            BBPSSettings.discard({ "taskId": $rootScope.taskID }, onDiscardSuccess, onDiscardError);
            $uibModalInstance.dismiss('cancel');
        }

        function onDiscardSuccess(result) {

            $rootScope.removeRow($rootScope.taskID);
        }
        function onDiscardError(error) {

        }


        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
